module.exports = __webpack_public_path__ + "img/chinese.9ac6fd96.png";